const platformPage = (gsap, mm, ScrollTrigger, smoother) => {
  
  /***************************************************************
    PARALLAX ITEMS
  ***************************************************************/
 
  const $container = $('.page-platform .platform-capabilities');
  const $title = $container.find('.platform-capabilities-title');
  const $content = $container.find('.platform-capabilities-items');
  const $tech = $('.platform-technology .copy');
      
  mm.add("(min-width: 768px)", () => {
    
    //smoother.effects($content, {speed: 1.2});
    
    let st = ScrollTrigger.create({
      trigger: $container,
      pin: $title,
      start: "top 100px",
      end: "100% 75%",
    });
    
    smoother.effects($tech, {speed: 1.2});
    
  }, '.page-platform');
  
  /***************************************************************
    PARTNERS GRID
  ***************************************************************/
 
  const $secondaryPartners = $('.partner-expand');
  const $partnersMore = $('#partnersMore');
  const $btnText = $partnersMore.find('span');

  $partnersMore.on('click', function() {
    
    const $this = $(this);
    smoother.paused(true);
    if ($btnText.text() == 'more') {

      $secondaryPartners.slideToggle({
        duration: 600,
        done: function() {
          //smoother.paused(true);
          
          $btnText.text('less');
          $this.addClass('open');
          ScrollTrigger.refresh();
          smoother.paused(false);

        }
      });

    } else {

      gsap.to(smoother, {
        scrollTop: smoother.offset($secondaryPartners, "top center"),
        duration: 0.6,
        onComplete: function() {

          $secondaryPartners.slideToggle(300, function() {
            //smoother.paused(true);
            //smoother.paused(false);
            $btnText.text('more');
            $this.removeClass('open');
            ScrollTrigger.refresh(true);
            smoother.paused(false);

          });

        }
      });

    }

  });

}

export {
  platformPage
};
